import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Update Course sections order
 * @param course_id
 * @param version
 * @param sections
 */
const updateCourseSectionsOrder = (
  course_id: string,
  version: number,
  sections: string[]
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL = routes.COURSE + course_id + '/' + version + '/sections/'
    const data = { sections }
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }
    AxiosClient.put(URL, data, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject('Error updating Section Items: ' + err)
      })
  })
}

export default updateCourseSectionsOrder
